import { useEffect } from "react";
import useUser from "../../../hooks/useUser";
import useLocationState from "../../../hooks/useLocationState";
import CRMWrapper from "./CRMWrapper";
import ViewPort from "../../Layout/ViewPort";

const CRM = (props) => {
  const { state } = useLocationState();
  const { setTitle } = useUser();

  useEffect(() => {
    document.title = "ScholarSift - CRM";
    setTitle("CRM");
    return () => {
      setTitle("");
    };
  });

  return (
    <ViewPort>
      <div
        style={{
          minHeight: state.viewport.h - (state.viewport.m + state.viewport.f),
        }}
      >
        <CRMWrapper />
      </div>
    </ViewPort>
  );
};

export default CRM;
